import React from 'react'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import { ReactComponent as Shape1 } from '../../assets/svg/faq-banner-circle.svg'
import { ReactComponent as Shape2 } from '../../assets/svg/faq-banner-item-1.svg'
import { ReactComponent as Shape3 } from '../../assets/svg/faq-banner-item-2.svg'
import { TABLET } from '../../lib/constant'

export default function FAQBanner() {
	return (
		<Section>
			<Content>
				<Text>
					<h1>자주하는 질문</h1>
					<h2>자주하는 질문을 모아 놓았습니다.</h2>
				</Text>
				<Shapes>
					<Shape1 className="shape shape1" />
					<Shape2 className="shape shape2" />
					<Shape3 className="shape shape3" />
				</Shapes>
			</Content>
		</Section>
	)
}

const Section = styled.section`
	height: 360px;
	width: 100%;
	background-color: #ffdc60;
	overflow: hidden;

	${down(TABLET)} {
		height: 255px;
	}
`

const Content = styled.div`
	max-width: 1440px;
	width: 100%;
	height: 100%;
	margin: 0 auto;
	position: relative;
`

const Text = styled.div`
	display: flex;
	flex-direction: column;
	width: 50%;
	margin-left: auto;
	padding-top: 150px;
	position: relative;
	z-index: 1;

	> h1 {
		font-size: 72px;
		line-height: 80px;
		color: #131313;
		font-weight: 700;
		letter-spacing: -0.02em;
	}

	> h2 {
		font-size: 24px;
		line-height: 28px;
		color: #131313;
		margin-top: 32px;
		letter-spacing: -0.02em;
	}

	${down(TABLET)} {
		width: 100%;
		padding: 40px 16px;
		height: 100%;
		justify-content: flex-end;

		> h1 {
			font-size: 48px;
			line-height: 56px;
		}
		> h2 {
			font-size: 18px;
			line-height: 24px;
			margin-top: 8px;
		}
	}
`

const Shapes = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;

	> .shape {
		position: absolute;

		&.shape1 {
			top: 0;
			left: 370px;
		}
		&.shape2 {
			bottom: 0;
			left: 0;
		}
		&.shape3 {
			right: 60px;
			top: 0;
		}

		${down(TABLET)} {
			&.shape1 {
				top: -14px;
				left: 75px;
				width: 210px;
				height: 210px;
			}
			&.shape2 {
				bottom: 0;
				left: -185px;
				width: 314px;
				height: 140px;
			}
			&.shape3 {
				right: -16px;
				top: -16px;
				width: 60px;
				height: 150px;
			}
		}
	}
`
